import { API_Data_Free_Trial_Response } from "@/interfaces/api/purchases/api_response_types"
import { API_Error, API_Response, API_Success_Response } from "@/interfaces/api/response/api_response_types"
import { fetcher } from "@/utils/helpers"

export async function freeTrial(): Promise<API_Data_Free_Trial_Response> {
    const res = await fetcher(`/api/self/purchases/free-trial`, { 
    method: 'POST',
    cache: "no-store",
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    }
  })

  const response = await res.json() as API_Response<API_Data_Free_Trial_Response>

  if (!res.ok) throw { code: res.status, description: 'Unknow free trial error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Free trial data missing in response' } as API_Error

  return response.data
}

export async function promoCode(code: string): Promise<API_Response> {
    const res = await fetcher(`/api/self/purchases/promo-code?code=${encodeURIComponent(code)}`, { 
    method: 'POST',
    cache: "no-store",
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    }
  })

  const response = await res.json() as API_Response

  if (!res.ok) throw response.error
  if (response.status === 'error') throw response.error

  return response
}